import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * CoreModule
 * Centralized place for singleton services, global interceptors, and core logic.
 */
@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: []
})
export class CoreModule { }
